export const common = {
    password: {
        type: 'string',
        length: { minimum: 5, maximum: 65 },
        presence: { allowEmpty: false },
    },
    password_confirmation: {
        type: 'string',
        length: { minimum: 5, maximum: 65 },
        presence: { allowEmpty: false },
    },
};
